<template>
  <div>
    <div class="mb-6 pb-6 border-b-2 border-grey-light flex flex-wrap items-center">
      <div>
        <h1 class="text-grey-darker text-xl font-semibold leading-normal uppercase">
          Plans & Pricing
        </h1>
        <h2  class="text-grey-dark text-sm font-medium leading-normal">
        </h2>
      </div>
    </div>
    <!-- PACK SELECTION -->
    <guild-plan-compare />

  </div>
</template>
<script>
import GuildPlanCompare from './GuildPlanCompare'
export default {
  components: {
    GuildPlanCompare
  }
}
</script>
